import React from "react";
import { Link } from "@quintype/components";
import { string } from "prop-types";

import "./excerpt.m.css";

const Excerpt = ({
  excerpt = "",
  excerptLink = "",
  datatrackingcategory = "",
  datatrackingaction = "",
  datatrackinglabel = "",
}) => {
  return (
    <p styleName="excerpt" className="excerpt">
      <Link
        href={excerptLink}
        data-tracking-category={datatrackingcategory}
        data-tracking-action={datatrackingaction}
        data-tracking-label={datatrackinglabel}
      >
        {excerpt}
      </Link>
    </p>
  );
};

Excerpt.propTypes = {
  excerpt: string,
  excerptLink: string,
  datatrackingcategory: string,
  datatrackingaction: string,
  datatrackinglabel: string,
};

export default Excerpt;
